module.exports = __webpack_public_path__ + "img/podpis_rezervacna_zmluva.50a51475.svg";